/* eslint-disable max-len */
import React from 'react'
import styled from 'styled-components'
import colors, { Color } from '../../theme/colors'
import fonts from '../../theme/fonts'
import CheckSvg from '../Icons/Button/Check'
import { toBase64 } from '../../../util/image'

const CheckIconBase64 = color =>
  toBase64(<CheckSvg width={11} height={11} color={color} />)

const CheckIconDisabledBase64 = 
  toBase64(<CheckSvg width={11} height={11} color={colors.Primary.Grey} />)

export const StyledCheckbox = styled.div<{
  disabled: boolean
  color: Color
}>`
  display: flex;
  align-items: flex-start;
  font-family: ${fonts.fontFamilies.Inter};
  font-weight: ${fonts.fontWeights.small};
  font-style: normal;
  font-size: ${fonts.fontSizes.p16};
  line-height: 16px;

  &:hover {
    cursor: pointer;
    &input[type='checkbox'] {
      border: 1px solid ${colors.Primary.GreyTextLight};
    }
  }

  input[type='checkbox'] {
    -moz-appearance: none;
    -webkit-appearance: none;
    -o-appearance: none;
    margin: 0 0 0 0;
    height: 16px;
    min-width: 16px;
    border-radius: 3px;
    position: relative;
    border: 1px solid ${colors.Primary.Grey};
    border-radius: 3px;
    background-color: ${colors.Primary.White};
    &:hover {
      cursor: pointer;
    }

    &:checked {
      background-color: ${colors.Primary.yellow500};
      border: none;

      &:before {
        content: url('data:image/svg+xml;base64,${props => CheckIconBase64(props.color)}');

        justify-content: center;
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
      }

      &:disabled:before {
        content: url('data:image/svg+xml;base64,${CheckIconDisabledBase64}');
      }
    }

    &:hover {
      border: 1px solid ${colors.Primary.GreyTextLight};
    }

    &:disabled {
      background-color: ${colors.Primary.GreyLight};
      color: ${colors.Primary.Grey};
      cursor: not-allowed;
    }
  }

  label {
    margin-left: 16px;
    color: ${({ disabled }) => (disabled ? colors.Primary.Grey : colors.Primary.Black)};

    &:hover {
      cursor: pointer;
    }
  }
`
